import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'

export const useConfirmProductsMutation = (onSettled: () => void) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: confirmProductsMutation } = useMutation({
		mutationFn: (ids: number[]) => {
			return axiosPrivate.post(apiRoutes.productsConfirm, { ids })
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.products.all })
			useToast({
				type: 'success',
				message: t('Products confirmed')
			})()
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		confirmProductsMutation
	}
}
